import { getClaimsData } from '../../../store/orm/Claim/selectors';

export default (state, { match }) => {
  return {
    claims: getClaimsData(state, match.params.parcelId),
  };
};
